export default __webpack_public_path__ + "static/media/Martiyers7.9203c274.jpg";